// Copies first. These arrays come from RTK Query and Strapi caches other screens read.
export const shuffled = <T>(items: readonly T[]): T[] => {
    const copy = [...items];

    for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }

    return copy;
};
